var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mt-2",attrs:{"dense":"","type":_vm.type},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-icon',{staticClass:"mr-4"},[_vm._v(_vm._s(_vm.icon))])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }